import { render, staticRenderFns } from "./benchmarkTotalChart.vue?vue&type=template&id=0dc0ef42&"
import script from "./benchmarkTotalChart.vue?vue&type=script&lang=js&"
export * from "./benchmarkTotalChart.vue?vue&type=script&lang=js&"
import style0 from "./benchmarkTotalChart.vue?vue&type=style&index=0&id=0dc0ef42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports